/**
 * zh-CN labels for the auto-assign enums. Kept as a map rather than inline template branches so a new
 * backend reason surfaces as its raw name instead of silently rendering blank.
 */
export const TREATMENT_AUTO_ASSIGN_STATUS_LABELS: Readonly<Record<string, string>> = Object.freeze({
    Ready: '待处理',
    InProgress: '处理中',
    Assigned: '已分配',
    Skipped: '已跳过',
    Failed: '失败',
});

export const TREATMENT_AUTO_ASSIGN_SKIP_REASON_LABELS: Readonly<Record<string, string>> = Object.freeze({
    AlreadyAssigned: '已有设计师',
    AssignedConcurrently: '处理期间已被他人分配',
    TreatmentTypeNotGrouped: '订单类型未分组',
    NoActiveShift: '当前无生效班次',
    NoOneOnShift: '当前班次无排班人员',
    NoGroupDesignerOnShift: '班次内无该分组设计师',
    FeatureDisabled: '功能未启用',
    BeforeCutoff: '早于启用时间',
    TreatmentTypeOutOfScope: '不在生效范围内',
});

export const TREATMENT_AUTO_ASSIGN_STRATEGY_LABELS: Readonly<Record<string, string>> = Object.freeze({
    None: '-',
    RuleDesigner: '规则指定',
    RoundRobin: '轮转',
});

export const TREATMENT_AUTO_ASSIGN_TRIGGER_LABELS: Readonly<Record<string, string>> = Object.freeze({
    FirstSync: '首次同步',
    Sweeper: '定时补偿',
    Manual: '手动触发',
});
